import StarIcon from "@mui/icons-material/Star";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { useSession } from "@src/appV2/Auth/api/useSession";
import { APP_V2_USER_EVENTS, logEvent } from "@src/appV2/lib/analytics";
import { Text } from "@src/lib/ui-react";

import { usePostStarredProfessional } from "../../api/starredProfessionals/usePostStarredProfessional";

interface StarredProfessionalConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  workerName: string;
  workplaceId: string;
  workerId: string;
  setIsStarred?: (isStarred: boolean) => void;
}

export function StarredProfessionalConfirmationModal({
  isOpen,
  onClose,
  workerName,
  workplaceId,
  workerId,
  setIsStarred,
}: StarredProfessionalConfirmationModalProps) {
  const { mutateAsync: starProfessional } = usePostStarredProfessional({
    workplaceId,
    professionalId: workerId,
  });
  const { userId } = useSession();

  const handleStarProfessional = async () => {
    try {
      setIsStarred?.(true);
      onClose();
      await starProfessional();
    } catch {
      setIsStarred?.(false);
    }
  };

  return (
    <Dialog fullWidth open={isOpen} maxWidth="md" scroll="paper" onClose={onClose}>
      <DialogTitle>
        <Text variant="h4">Add {workerName} to your starred list</Text>
      </DialogTitle>
      <DialogContent dividers>
        <Text variant="body1">
          Once starred, the professional will be notified when you post new shifts and highlighted
          in your chat and invite lists.
        </Text>
        <DialogActions>
          <Button
            variant="outlined"
            color="primary"
            size="medium"
            sx={{ border: (theme) => `1px solid ${theme.palette.divider}` }}
            onClick={() => {
              logEvent(APP_V2_USER_EVENTS.STARRED_PROFESSIONAL_CONFIRMATION_MODAL_CANCELLED, {
                workerId,
                workplaceId,
                workplaceUserId: userId,
              });
              onClose();
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            startIcon={<StarIcon />}
            size="medium"
            onClick={handleStarProfessional}
          >
            Add to starred
          </Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
}
